module.exports = __webpack_public_path__ + "media/warranty/transfer-card-icon-05bc0830.png";